import * as $ from "jquery";

export class Objects {
    public static cloneObject<TType>(input: TType): TType {
        if (input === undefined || input === null || typeof input !== "object") {
            return input;
        }

        if (Array.isArray(input)) {
            return (input as any).map((x) => Objects.cloneObject(x));
        }

        return $.extend(true, {}, input);
    }
}
